import React from 'react';
import moment from 'moment';
import StatusBadge from './StatusBadge';

const SKURow = ({
  variant,
  locationsBySelectedRegion,
  findSKUStatus,
  tableData,
  expandedRegions,
  pendingData,
  pendingDataUS,
  pendingDataUK,
  getLocationDisplayName,
}) => {
  const calculateRegionTotal = (regionLocations, region) => {
    const total = regionLocations.reduce(
      (sum, location) => sum + (variant.locationCounts[location] || 0),
      0
    );

    let pending = 0;
    if (region === 'AU' && pendingData) {
      pending = pendingData[variant.sku] || 0;
    } else if (region === 'US' && pendingDataUS) {
      pending = pendingDataUS[variant.sku] || 0;
    } else if (region === 'UK' && pendingDataUK) {
      pending = pendingDataUK[variant.sku] || 0;
    }

    return total - pending;
  };

  const getNextContainer = (region) => {
    const container = tableData[variant.sku];
    if (!container) return '';

    const regionKey = region.toLowerCase() + 'NextContainer';
    const nextContainer = container[regionKey];

    if (nextContainer?.date) {
      return `${moment(nextContainer.date).format('DD-MMM-YYYY')}`;
    }
    return '';
  };

  const getPendingForRegion = (region) => {
    if (region === 'AU' && pendingData) {
      return pendingData[variant.sku] || 0;
    } else if (region === 'US' && pendingDataUS) {
      return pendingDataUS[variant.sku] || 0;
    } else if (region === 'UK' && pendingDataUK) {
      return pendingDataUK[variant.sku] || 0;
    }
    return 0;
  };

  return (
    <tr className="border-b hover:bg-gray-50">
      <td className="px-3 py-2 sticky left-0 bg-white border-r min-w-[200px] max-w-[250px]">
        <div className="pl-4">
          <span className="text-sm block truncate" title={variant.sku}>
            {variant.sku}
          </span>
        </div>
      </td>
      {Object.entries(locationsBySelectedRegion).map(([region, locations]) => (
        <React.Fragment key={region}>
          <td className="px-3 py-2 text-center border-r">
            {calculateRegionTotal(locations, region)}
          </td>
          {expandedRegions[region] && (
            <>
              <td className="px-3 py-2 text-center border-r">
                <StatusBadge status={findSKUStatus(variant.sku, region)} />
              </td>
              <td className="px-3 py-2 text-center border-r">
                <span className="inline-flex items-center gap-1 text-sm">
                  {getNextContainer(region)}
                </span>
              </td>
              <td className="px-3 py-2 text-center border-r">
                <span className="text-red-600">
                  {getPendingForRegion(region)}
                </span>
              </td>
              {locations.map((location) => (
                <td key={location} className="px-3 py-2 text-center border-r">
                  {variant.locationCounts[location] || 0}
                </td>
              ))}
            </>
          )}
        </React.Fragment>
      ))}
    </tr>
  );
};

export default React.memo(SKURow);
